import './legal.dish.styles.scss';
export default function LegalDishComponent() {

    return <div className="LegalDishComponent">
        <i className='las la-lock' />
        Llamadas securizadas por protocoles <b>HTTPS</b> sobre servidores de <b>Comitas</b>.
    </div>

}